export { default } from './LeftPanelEOY2025';
